var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "help" },
    [
      _c("layout-header"),
      _c("heading-title", {
        scopedSlots: _vm._u([
          {
            key: "main",
            fn: function() {
              return [_c("p", [_vm._v("Q&A")])]
            },
            proxy: true
          },
          {
            key: "sub",
            fn: function() {
              return [_c("p", [_vm._v("サービスに関する質問_")])]
            },
            proxy: true
          }
        ])
      }),
      _c("div", { staticClass: "help__main center" }, [
        _c(
          "ul",
          { staticClass: "help__main__slide" },
          _vm._l(_vm.helpList, function(help) {
            return _c("list-slide", {
              key: help.id,
              staticClass: "help__main__slide__list",
              attrs: { title: help.title, text: help.text }
            })
          }),
          1
        )
      ]),
      _c("layout-footer")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }